@if (draftOperationsService.operationGroupData.operationType === operationTypeEnum.Souscription) {
  <oui-autocomplete
    label="Enveloppe"
    [control]="enveloppeControl"
    [options]="enveloppeAutocompleteOptions"
    [displayResetButton]="true"
  class="width-100pc"></oui-autocomplete>
}
@if (isSouscription && selectedEnveloppeId && !isSelectedEnvelopeHabilited) {
  <oui-banner
    title="Vous n'avez aucune habilitation active pour cette enveloppe"
    declination="error"
    [action]="noHabilAction"
  [showCloseButton]="false"></oui-banner>
}
<app-transaction-personnelle
  [isPsi]="isPsiTransaction"
  [withCoInvestisseur]="draftOperationsService.withCoInvestisseur"
  [habilitationIds]="selectedEnveloppeHabilitationIds"
  [initValue]="draftOperationsService.operationGroupData.transactionPersonnelleStatut"
(onTransactionPersonnelleChange)="updateTransactionPersonelleStatut($event)"></app-transaction-personnelle>

@if (
  draftOperationsService.operationGroupData.operationType === operationTypeEnum.ActeDeGestion || selectedEnveloppeId
  ) {
  @for (operation of draftOperationsService.operationGroupData.operations; track operation; let index = $index) {
    <app-operation-information-form
      [operation]="operation"
      [index]="index"
      [expanded]="index === draftOperationsService.operationGroupData.operations.length - 1"
      [deleteDisabled]="draftOperationsService.operationGroupData.operations.length <= 1"
      [selectableProduits]="selectableProduits"
      (onSpecificDataChanged)="onSpecificDataChange($event, index)"
      (onOperationConfigChanged)="onOperationConfigChanged($event, index)"
      (onProductChanged)="onProductChanged($event, index)"
      (onDeleteClicked)="deleteOperation($event)">
    </app-operation-information-form>
  }
  <div class="flex-none">
    @if (draftOperationsService.operationGroupData.operations[0]?.operationConfig?.allowMultiple) {
      <oui-button
        type="outlined"
        (click)="addNewOperationInGroup()"
        >
        {{ addButtonLabel }}
      </oui-button>
    }
  </div>
}
